module.exports = __webpack_public_path__ + "static/img/tupian1.a98a5fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tupian1.png
// module id = 82oC
// module chunks = 2